import { useEffect } from "react";
import Header from "../../../component/header/Header";
import Table from "../../../component/table/Table";
import { fetchCompanyTypes } from "../../../features/company/companyThunk";
import tableData from "../../../utils/logisticaStabilimenti.json";
import { useDispatch } from "react-redux";

const StabilimentiAnagrafiche = () => {

  const dispatch = useDispatch()
  useEffect(() => {
     dispatch(fetchCompanyTypes());
   }, [dispatch]);
  const columns = [
    {
      field: "nomeStabilimento",
      headerName: "Nome dello stabilimento",
      width: 610,
    },
    { field: "tipologia", headerName: "Tipologia", width: 300 },
    { field: "indirizzo", headerName: "Indirizzo", width: 530 },
    { field: "operativoDa", headerName: "Operativo da", width: 130 },
    { field: "utente", headerName: "Utente", width: 85 },
    { field: "azioni", headerName: "Azioni", width: 95 },
  ];

  return (
    <>
      <Header />
      <div className="pageTemplate">
        <Table data={tableData} columns={columns} navData={"stabilimenti"} />
      </div>
    </>
  );
};

export default StabilimentiAnagrafiche;
